module.exports = __webpack_public_path__ + "static/media/pricescope-container-img.51ca748d.png";